export const visitedTabsState = (props, state) => {
  if (!props.keepMounted) return null;
  const name = props.tabs[props.selectedIndex]?.name;
  const visitedTabs = state.visitedTabs.filter(visited => props.tabs.some(tab => tab.name === visited));
  if (name && !visitedTabs.includes(name)) visitedTabs.push(name);
  return { visitedTabs };
};
